import { FolderInput, Undo2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { MoveOutcome } from "@/hooks/useProjectMove";
import { cn } from "@/lib/utils";

/** Result of the last move with a one-step Undo; placed where the selection toolbar was. */
export function MoveResultBar({
  outcome,
  busy,
  onUndo,
  onDismiss,
  className,
}: {
  outcome: MoveOutcome;
  busy: boolean;
  onUndo: () => void;
  onDismiss: () => void;
  className?: string;
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="move-result-bar"
      className={cn(
        "flex max-w-full items-center gap-2 rounded-2xl border border-studio-border-light bg-studio-panel/95 py-1.5 pl-3 pr-1.5 shadow-panel backdrop-blur",
        className
      )}
    >
      <FolderInput className="h-4 w-4 shrink-0 text-studio-accent" />
      <span className="min-w-0 flex-1 text-xs text-studio-ink">{outcome.message}</span>
      {outcome.result.moved.length > 0 && (
        <Button type="button" size="sm" variant="secondary" loading={busy} onClick={onUndo} className="shrink-0 sm:h-9">
          <Undo2 className="h-4 w-4" />
          Undo
        </Button>
      )}
      <button
        type="button"
        onClick={onDismiss}
        disabled={busy}
        aria-label="Dismiss"
        title="Dismiss"
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-studio-muted hover:bg-studio-card hover:text-studio-ink focus-visible:outline-none focus-visible:shadow-glow-sm sm:h-9 sm:w-9"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
